import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useDispatch, useSelector } from "react-redux";
import {
  userTypedRepairReasons,
  selectedRepairReasonObject,
  eligibilityResponseObject,
} from "../../ducks/redux/actions/dashboardReducer.actions";
import {
  userChosenPropertyId,
  userChosenHighLevelDescription,
  userChosenSOR,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  isEditState,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenDuplicateQuestion,
  userChosenEmergencyQuestion,
  repairPriorityValue,
  showFooter,
  DMCChecksavedAnswer,
} from "../../ducks/redux/actions/userChoices";
import { PremisesType } from "../../models/Customer";
import * as api from "../../api";
import { useTranslation } from "react-i18next";
import {
  EligibilityErrorCode,
  MaintenanceResponsibility
} from "../../models/Property";
import Loader from "react-loader-spinner";
import { RouteComponentProps } from "react-router-dom";
import {
  getHeatingHotWaterCase,
  getMaintResp,
  getRepairResp,
} from "../../ducks/redux/actions/getAddress";
import Message from "../../storybook/Message";
import { isNullOrUndefined } from "../../utils/formatting";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { RepairLocationPriorityPayload, RepairPriorityCode } from "../../models/Repair/RepairPriority";
import moment from "moment";
import { isContinueButtonDisabled, RemoveAllDMCData, storeSORDAMP } from "../../ducks/redux/actions/FinancialReferral";
import { RepairPriority } from "../../models/Repair/CreateRepair";

export interface RepairReasonProps extends RouteComponentProps<any> {
  suggestions: string[];
  setButtonDisabled: (a: boolean) => void;
  locatioAlert: string[];
  getMandatoryData: (args: any) => void;
}
const RepairReason: React.FC<RepairReasonProps> = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  //fetch typed object
  const fetchedRepairReasonsSelection = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.fetchedRepairReasonsSelect
  );

  const userChosenHighLevelDescriptionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription
  );

  let suggestionList;
  const [eligible, setEligible] = useState("none");
  const [errorCode, setErrorCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [userInput, setUserInput] = useState();
  const [inputValue, setInputValue] = useState(userChosenHighLevelDescriptionBackButton ?? "");
  const [isOrbisBlockMsg, setIsOrbisBlockMsg] = useState(false);
  const [blockEMERepair, setBlockEMERepair] = useState(false);
  const [isSelectedValue, setSelectedValue] = useState(false);
  const [repairReasonEvent, setRepairReasonEvent] = useState(null);
  const [matchedRepairReason, setMatchedRepairReason] = useState<any>(null);
  let parentAssetType: any = null;
  let assetSubType: any = null;
  let [currentRepairAsset, setCurrentRepairAsset] = useState<any>(null);
  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses?.saveCustomerDetails
  );

  const [fetchedRepairReasonsData, setData] = useState(props.suggestions);
  //Check Repair Eligibility
  let premisesType = "";
  let maintsResp = "FMFULL";
  let repairResp = "";
  let additionalRepairInfo = false; //!!asset?.description //??
  let isRepairEligible = true;
  let isCustomerView = false; // to do discuss
  let uprn = ""; // asset store - filter
  let sorCode: string | null = "";
  let isInDefects = false; //got
  let heatingRepairContext: string | null = "";

  const addressesData = useSelector(
    (state: any) => state?.addresses?.customerassociatedassets
  );
  const checkEnhancedEligibility = useSelector(
    (state: any) => state.userChoicesReducer?.checkEnhancedRepairEligibilityMyPeabody
  );
  const selectedproperty = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.tracks?.[0]?.assetType
  );

  const selectedPropertyId = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.tracks?.[0]?.assetId
  );

  const selTenancyGroup = useSelector(
    (state: any) => state?.userChoicesReducer?.selectedTenancyGroup
  );

  const RepairLocationId = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenRepairLocationId
  );

  //selector for fetching supplimentaryCodes
  const supplimentaryCodes = useSelector(
    (state: any) => state.userChoicesReducer?.supplimentaryCodes
  );
  const assetId = useSelector(
    (state: any) => state?.addresses?.assetId
  );

  const fetchAppConfigHotjarToggleValue = async () => {
    try {
      const SORConfig = await api.GetAppConfigToggleValue("dmcsorcodes");
      dispatch(storeSORDAMP(SORConfig?.value))
    } catch (error) {
      console.log("Error fetching SOR Config: ", error);
    }
  }

  useEffect(() => {
    if (blockEMERepair) {
      dispatch(isContinueButtonDisabled(true));
    } else {
      dispatch(isContinueButtonDisabled(false));
    }
  }, [blockEMERepair])


  useEffect(() => {
    if (props.history.action === "POP" || userChosenHighLevelDescriptionBackButton) {
      setInputValue(userChosenHighLevelDescriptionBackButton);
      setSelectedValue(true)
      repairReasonChangeAction("pageInit", userChosenHighLevelDescriptionBackButton);
    }
    fetchAppConfigHotjarToggleValue()
  }, []);


  useEffect(() => {
    props.getMandatoryData(inputValue);

  }, [inputValue]);

  const getPremisesData = async (value: string) => {
    try {
      setIsLoading(true);
      const selectedReasonFiltered = fetchedRepairReasonsSelection?.filter(
        (reason: any) => reason.description === value
      );
      const selectedReason = selectedReasonFiltered?.length > 0 ? selectedReasonFiltered[0] : null;
      if (!isNullOrUndefined(selectedReason)) {
        dispatch(selectedRepairReasonObject(selectedReasonFiltered));
        setMatchedRepairReason(selectedReason);
        //call api and set params values
        const Property = selectedPropertyId ?? assetId
        if (isNullOrUndefined(currentRepairAsset)) {
          const assetDetails = await api.getAssetsByid(Property);
          assetSubType = assetDetails.assetSubType;
          const currentAssetId = assetDetails.id;

           const getParentAssetType = async(assetId: string) => {
            if (!Array.isArray(addressesData)) return null;
            // Flatten addressesData if it's an array of arrays
            const flatAddresses = Array.isArray(addressesData[0])
              ? addressesData.flat()
              : addressesData;
            const idx = flatAddresses.findIndex((item: any) => item.id === assetId);
            if (idx === -1) return null;
            // Find the next asset that is not a "Divided Block"
            for (let i = idx + 1; i < flatAddresses.length; i++) {
              if (flatAddresses[i].assetType !== "Divided Block") {
                return flatAddresses[i].assetType;
              }
            }
            return null;
          }
    
          parentAssetType = await getParentAssetType(currentAssetId)
          dispatch(userChosenPropertyId(assetDetails.id));
          currentRepairAsset = assetDetails;
        }
        if (currentRepairAsset) {
          // setIsLoading(false)
          dispatch(eligibilityResponseObject(currentRepairAsset));
          premisesType = currentRepairAsset?.assetType;

          maintsResp =
            currentRepairAsset?.maintenanceResponsibilities?.find(
              (resp: any) => resp.type === "MAINTSRESP"
            )?.value ?? "";
          repairResp =
            currentRepairAsset?.maintenanceResponsibilities?.find(
              (resp: any) => resp.type === selectedReason?.element
            )?.value ?? "";

          if (selectedReason?.additionalData?.length > 0) {
            additionalRepairInfo =
              selectedReason?.additionalData[0]?.description != ""
                ? true
                : false;
          }
          else {
            additionalRepairInfo = false
          }
          //start logic to get isEligibleRepair
          const asset = selectedReason.additionalData.find(
            (item: any) =>
              item.assetType === selectedproperty &&
              item.tenancyTypes?.some(
                (tt: any) =>
                  tt.toLowerCase() ===
                  selTenancyGroup.toLowerCase()
              )
          );

          isRepairEligible = asset?.isEligible ?? false;
          // end
          isCustomerView = true; // as discussed true for customer search
          uprn = currentRepairAsset.uprn;
          //added check for SupplementaryCode 
          sorCode = selectedReason?.sors[0]?.sorCode;
          const status =
            currentRepairAsset.statuses &&
            currentRepairAsset.statuses.isInDefects;
          isInDefects = status;
          dispatch(userChosenSOR(sorCode));
          dispatch(userChosenSTATUS("Unappointed,Appointed,In Progress"));

          dispatch(getMaintResp(maintsResp));
          dispatch(getRepairResp(repairResp));

          // Implementation for Heating or hot water repair US
          let maintenanceResponsibilities: MaintenanceResponsibility[] = [];
          if (value === "Heating or hot water repair" || sorCode === "COMHIU") {
            try {
              // get maintenanceResponsibilities for all assets
              addressesData.forEach((element: any) => {
                const promises = element.map((item: any) => {
                  return api.getAssetsByid(item.id);
                });
                Promise.all(promises).then((results) => {
                  results.forEach((item: any) => {
                    const responsibilities = heatingAttributeFromResponsibilities(
                      item.maintenanceResponsibilities
                    );
                    const rep = {
                      type: item.assetType,
                      value: responsibilities,
                    };
                    maintenanceResponsibilities.push(rep);
                  });

                  if (
                    maintenanceResponsibilities &&
                    maintenanceResponsibilities.length > 0
                  ) {
                    const propertyAttribute =
                      maintenanceResponsibilities.filter((item) => {
                        return item.type === PremisesType.Property
                          ? item.value
                          : "";
                      })[0]?.value ?? "";
                    const dividedBlockAttribute =
                      maintenanceResponsibilities.filter((item) => {
                        return item.type === PremisesType.DividedBlock
                          ? item.value
                          : "";
                      })[0]?.value ?? "";
                    const blockAttribute =
                      maintenanceResponsibilities.filter((item) => {
                        return item.type === PremisesType.Block ? item.value : "";
                      })[0]?.value ?? "";
                    const estateAttribute =
                      maintenanceResponsibilities.filter((item) => {
                        return item.type === PremisesType.EstateArea;
                      })[0]?.value ?? "";

                    // call sor determination api
                    const sorDeterminationResponse = api.getSorDetermination({
                      propertyAttribute,
                      dividedBlockAttribute,
                      blockAttribute,
                      estateAttribute,
                      context: currentRepairAsset.assetType as PremisesType,
                    }).catch(err => {
                      console.error(err);
                      props.history.push({
                        pathname: '/repairJourneyErrorPage',
                        state: { message: 'repair_Journey_Error_Message1' }
                      });
                    });
                    Promise.resolve(sorDeterminationResponse).then(async (results) => {
                      if (results) {
                        if (sorCode === "COMHIU" && results?.repairContext !== "N/A") {
                          heatingRepairContext = results.repairContext;
                          dispatch(userChosenSOR(sorCode));
                          setEligible("none");
                          await checkRepairEligibility(selectedReason);
                        }
                        else if (results?.errorCode && !checkEnhancedEligibility) {
                          if (results.errorCode === "E32") {
                            setErrorCode("SSR047");
                            setEligible("block");
                            if (isSelectedValue) { props.setButtonDisabled(false) }
                            dispatch(userChosenSOR(""));
                            setIsLoading(false);
                            dispatch(getHeatingHotWaterCase(results.errorCode));
                          } else {
                            setErrorCode("SSR049");
                            setEligible("block");
                            props.setButtonDisabled(true);
                            setIsLoading(false);
                            dispatch(userChosenSOR(results.sor));
                          }
                        } else {
                          sorCode = results.sor;
                          dispatch(userChosenSOR(results?.sor));
                          setEligible("none");
                          await checkRepairEligibility(selectedReason);
                        }

                        dispatch(userChosenSOR(results?.sor));
                      }
                    });
                  }
                });
              });
            } catch (e) {
              console.error(e);
              dispatch(showFooter(true));
              props.history.push({
                pathname: '/repairJourneyErrorPage',
                state: { message: 'repair_Journey_Error_Message1' }
              });
            }
          } else {
            //call eligibility api
            await checkRepairEligibility(selectedReason);
          }
        }
      }

    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    } finally {
      setIsLoading(false);
    }
  };

  const evaluateEnhancedRepairEligibility = async (selectedReason: any, sorCode: any) => {
    if (checkEnhancedEligibility) {
      try {
        // call Enhanced Repair Eligibility api
        const advancedPayload = {
          priority: selectedReason?.priority === RepairPriority.Emergency
            ? RepairPriorityCode.Emergency : RepairPriorityCode.NextAvailable,
          sor: sorCode || undefined,
          channel: "CustomerSelfService",
        };
        const response =
          await api.postEnhancedRepairEligibility(
            advancedPayload
          );
        if (
          response?.isEligible === false &&
          response?.errorCode === "E35"
        ) {
          setIsOrbisBlockMsg(true);
          setErrorCode("");
        }
        if (
          response?.isEligible === false &&
          response?.errorCode === "E36"
        ) {
          setBlockEMERepair(true);
          setErrorCode("");
        }

        return response.isEligible
      } catch (e) {
        console.error(e);
        dispatch(showFooter(true));
        props.history.push("/repairJourneyErrorPage");
      }
    }
    return true;
  }
  const checkRepairEligibility = async (selectedReason: any) => {

    let checkRepairEligibilityFlag = await evaluateEnhancedRepairEligibility(selectedReason, sorCode);
    if (checkRepairEligibilityFlag) {
      try {
        //call api and set errorMessage 
        const eligibilityResponse = await api.getRepairEligibility(
          premisesType,
          maintsResp,
          repairResp,
          additionalRepairInfo,
          isRepairEligible,
          isCustomerView,
          sorCode,
          uprn,
          isInDefects,
          heatingRepairContext,
          assetSubType,
          parentAssetType,
        );
        
        dispatch(userChosenEligibilityErrorCode(eligibilityResponse));
        if (eligibilityResponse != null && eligibilityResponse.length > 0) {
          if (isSelectedValue) { props.setButtonDisabled(false) }
          const isEligible = eligibilityResponse[0].isEligible;
          const error = isEligible
            ? eligibilityResponse[0].errorCode != EligibilityErrorCode.SSR037
              ? eligibilityResponse[0].errorCode != EligibilityErrorCode.E23
                ? ""
                : eligibilityResponse[0].errorCode
              : eligibilityResponse[0].errorCode
            : eligibilityResponse[0].errorCode;
          switch (error) {
            case EligibilityErrorCode.E3:
              setErrorCode(error);
              props.setButtonDisabled(true);
              setEligible("none");
              break;
            case EligibilityErrorCode.E4:
            case EligibilityErrorCode.E8:
            case EligibilityErrorCode.SSR037:
            case EligibilityErrorCode.E21:
            case EligibilityErrorCode.E22:
            case EligibilityErrorCode.E23:
            case EligibilityErrorCode.E24:
            case EligibilityErrorCode.E25:
            case EligibilityErrorCode.SSR005:
            case EligibilityErrorCode.SSR069:
              setErrorCode(error);
              props.setButtonDisabled(true);
              setEligible("block");
              break;
            case EligibilityErrorCode.ROOFINGALERT:
              setErrorCode(error);
              props.setButtonDisabled(true);
              setEligible("block");
              setErrorCode(error);
              break;
            default:
              if (isSelectedValue) { props.setButtonDisabled(false) }
              break;
          }

          if (!isRepairEligible) {
            setEligible("block");
          } else {
            setEligible("none");
            if (isSelectedValue) { props.setButtonDisabled(false) }
          }

          if (!isEligible) {
            if (
              error == EligibilityErrorCode.E2 &&
              selectedReason[0]?.additionalData[0]?.description != ""
            ) {
              setEligible("none");
              if (isSelectedValue) { props.setButtonDisabled(false) }
            } else {
              setEligible("block");
              props.setButtonDisabled(true);
              if (error == EligibilityErrorCode.E2)
                setErrorCode(EligibilityErrorCode.E2);
            }
          } else {

            if (
              eligibilityResponse[0].errorCode === EligibilityErrorCode.SSR037 ||
              eligibilityResponse[0].errorCode === EligibilityErrorCode.E23
            ) {
              setEligible("block");
            }
            if (isSelectedValue) { props.setButtonDisabled(false) }
          }
        }
        setIsLoading(false);
      } catch (e) {
        console.error(e);
        dispatch(showFooter(true));
        props.history.push({
          pathname: '/repairJourneyErrorPage',
          state: { message: 'repair_Journey_Error_Message1' }
        });
      }
    }
  };

  const inputTextChangeHandler = async (event: any, newValue: any) => {
    setSelectedValue(true);
    setRepairReasonEvent(event);
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(userChosenEmergencyQuestion(""));
      dispatch(isEditState(false));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenVandalismQuestion("No"));
      dispatch(userChosenAdditionalDescription(""));
      dispatch(userChosenDuplicateQuestion(""));
      dispatch(RemoveAllDMCData(null));
      dispatch(DMCChecksavedAnswer(""))
    }
    setUserInput(newValue);
    dispatch(userChosenHighLevelDescription(newValue));
    setIsLoading(true);
    setIsOrbisBlockMsg(false);
    setBlockEMERepair(false);
    setData(props.suggestions);
    const raisedFormattedDate = moment(new Date()).format("YYYY-MM-DDTHH:mm:ss");
    var repairPriorityReq = new RepairLocationPriorityPayload();
    const selectedReason = fetchedRepairReasonsSelection.filter(
      (reason: any) => reason.description === newValue
    );
    if (selectedReason?.length > 0 && selectedReason[0].sors.length > 0 && selectedReason[0].sors[0].sorCode) {
      selectedReason[0].sors[0].sorCode = getSorCode(selectedReason[0], supplimentaryCodes)
    }
    // Fetch workProgramme from the first matched reason's first SOR
    const workProgramme = selectedReason?.[0]?.sors?.[0]?.workProgramme;
    // Adding isANATypes for customer preferences
    let isAnaTypeValue = false;
    if (customerDetails?.preferences?.length > 0) {
      isAnaTypeValue = customerDetails?.preferences?.some((additionalNeedAlert: any) => additionalNeedAlert.preference.type === 'additionalNeeds');
    }
    let tenureCode = "";
    if (customerDetails?.tenanciesSummaries.length > 1) {
      const tenancySummary = customerDetails?.tenanciesSummaries?.filter(
        (tenancy: any) =>
          tenancy?.tenancySummary?.tenancyEndDate === null
      );
      tenureCode = tenancySummary[0]?.tenancySummary?.tenancyTenureCode;
    }
    else {
      tenureCode = customerDetails?.tenanciesSummaries[0]?.tenancySummary?.tenancyTenureCode;
    }
    // Fetch assetTypes from the first matched reason
    repairPriorityReq = {
      isEmergency: selectedReason?.[0]?.priority === "Emergency" ? true : false,
      repairType: selectedReason?.[0]?.sors?.[0]?.sorCode,
      isVulnerable: false,
      isRecall: false,
      isEMA: "N",
      channel: RepairChannel.CustomerSelfService,
      raisedDate: raisedFormattedDate,
      description: selectedReason?.[0]?.description,
      tenureCode: tenureCode,
      workProgramme: workProgramme,
      premisesType: selectedproperty,
      isAnaType: isAnaTypeValue,
      isV14Upgradable: selectedReason?.[0]?.isV14Upgradable,
    };

    try {
      const repairPriority = (await api.postRepairPriority(repairPriorityReq))?.repairPriority;
      dispatch(repairPriorityValue(repairPriority));
    } catch (err) {
      console.error(err);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    };
  };

  const suggestionClickHandler = (event: any, newInputValue: any) => {
    repairReasonChangeAction(event?.type, newInputValue);
    //getPremisesData(newInputValue)
  };

  useEffect(() => {
    suggestionClickHandler(repairReasonEvent, userInput);
  }, [isSelectedValue, repairReasonEvent, userInput]);

  const repairReasonChangeAction = (eventType: any, newInputValue: any) => {
    if (EditState === true) {
      dispatch(userChosenCovidQuestion(""));
      dispatch(userChosenVulnerabilityAdditionalInformation(""));
      dispatch(userChosenVulnerabilityQuestion("No"));
      dispatch(userChosenContactDetails(""));
      dispatch(userChosenContactPhone(""));
      dispatch(userChosenContactName(""));
      dispatch(userChosenRelationDetails(""));
      dispatch(userChosenEmergencyQuestion(""));
      dispatch(isEditState(false));
      dispatch(userChosenVandalismAdditionalInformation(""));
      dispatch(userChosenVandalismQuestion("No"));
      dispatch(userChosenDuplicateQuestion(""));
    }

    // NOTE 
    // Keyboard type: suggestionClickHandler, which is fine
    // User Select from Drop down: suggestionClickHandler => inputTextChangeHandler => suggestionClickHandler

    // ie. Continue will be enabled for appropriate messageing when page is initialized
    props.setButtonDisabled((!isNullOrUndefined(eventType) && eventType != "pageInit"));
    if (!isNullOrUndefined(eventType) && (eventType !== "click" || isSelectedValue === true)) {
      setSelectedValue(false)
      setInputValue(newInputValue);
      if (newInputValue !== "" && newInputValue !== matchedRepairReason?.description) {
        props.setButtonDisabled(true)
        setData(props.suggestions);
        dispatch(userTypedRepairReasons(newInputValue));
        dispatch(userChosenSOR(""));
        setErrorCode("");
        setIsOrbisBlockMsg(false);
        setBlockEMERepair(false);
        setEligible("none");
        getPremisesData(newInputValue);
      } else {
        // ie. Continue will be enabled for appropriate messageing when HLD is blank
        props.setButtonDisabled(false)
      }
    } else {
      // ie. Continue will be enabled for appropriate messageing when HLD is blank
      props.setButtonDisabled(false)
    }
  }

  if (
    props.locatioAlert &&
    props.locatioAlert.length > 1 &&
    !inputValue &&
    (RepairLocationId == 0 ||
      RepairLocationId === "No option selected global-txt")
  ) {
    suggestionList = (
      <div data-testid="alert-warning" role="alert" placeholder="alert-message">
        <Message className="error-msg" data-testid="locatioAlert_0">
          {props.locatioAlert[0]}
        </Message>

        <Message className="error-msg" data-testid="locatioAlert_1">
          {props.locatioAlert[1]}
        </Message>
      </div>
    );
  }
  else if (isOrbisBlockMsg) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="warning-msg" data-testid="OrbisBlock_warning">
        {t("OrbisBlockMsg1")}<br />
        {t('OrbisBlockMsg2')} <strong>{t('OrbisBlockNumber')}</strong> {t('OrbisBlockMsg3')}
      </Message>
    );
  } else if (blockEMERepair) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="warning-msg" data-testid="blockEMERepair_warning">
        {t("BlockEMERepairMsg")}<br />
      </Message>
    );
  } else if (
    props.locatioAlert &&
    props.locatioAlert.length == 1 &&
    (!inputValue ||
      RepairLocationId == 0 ||
      RepairLocationId === "No option selected global-txt")
  ) {
    suggestionList = (
      <Message className="error-msg" data-testid="alert-warning">
        <span data-testid="locatioAlert">{props.locatioAlert}</span>
      </Message>
    );
  } else if (!fetchedRepairReasonsData?.length && inputValue) {
    props.setButtonDisabled(true);
    suggestionList = (
      <Message className="error-msg">
        {t("Repair_Reason_NoMatch_Message")}
      </Message>
    );
  } else if (errorCode == EligibilityErrorCode.SSR037 && !inputValue) {
    let errorCodeArray: string[] = [];
    errorCodeArray = t(errorCode).split("?");
    let errorCodeValue = errorCodeArray[0];
    errorCodeArray = errorCodeArray.slice(1);
    let items = errorCodeArray.map((item, index) =>
      errorCode == EligibilityErrorCode.SSR037 ? (
        <strong>
          <li key={index}>{item}</li>
        </strong>
      ) : (
        <li key={index}>{item}</li>
      )
    );
    suggestionList = (
      <div
        data-testid="alert-warning"
        style={{ display: eligible }}
        className="alert alert-warning error-reason global-txt top-btm-padding"
        role="alert" placeholder="alert-message"
      >
        <span className="global-error-icon covid-error">
          <i className="fas fa-exclamation me-2"></i>
        </span>
        {errorCodeValue}
        {errorCode == EligibilityErrorCode.SSR037 ? (
          <ol>{items}</ol>
        ) : (
          <ul>{items}</ul>
        )}
      </div>
    );
  } else if (
    (errorCode == EligibilityErrorCode.SSR037 ||
      errorCode == EligibilityErrorCode.E21) &&
    inputValue
  ) {
    let errorCodeArray: string[] = [];
    errorCodeArray = t(errorCode).split("?");
    let errorCodeValue = errorCodeArray[0];
    errorCodeArray = errorCodeArray.slice(1);
    let items = errorCodeArray.map((item, index) =>
      errorCode == EligibilityErrorCode.SSR037 && [3, 4, 5].includes(index) ? (
        <strong>
          <li key={index}>{item}</li>
        </strong>
      ) : index === 2 && errorCode == EligibilityErrorCode.SSR037 ? (
        <li key={index}>
          {item.split(":")[0]}:<strong>{item.split(":")[1]}</strong>
        </li>
      ) : (
        <li key={index}>{item}</li>
      )
    );
    suggestionList = (
      <div
        data-testid="alert-warning"
        style={{ display: eligible }}
        className="warning mb-8"
        role="alert"
        placeholder="alert-message"
      >
        <div className="w-full px-2 py-2 bg-red-20 flex items-center">
          <div className="px-4 pr-8">
            <i className="fas fa-exclamation-circle me-2 text-brick-100 w-6 h-6 bolder-font"></i>
          </div>
          <div className="flex items-center text-black">
            <p className="w-full text-left my-2 font-AvantGardeGothic-Md">
              {errorCodeValue}
              {errorCode == EligibilityErrorCode.SSR037 ? (
                <ol>{items}</ol>
              ) : (
                <ul>{items}</ul>
              )}
            </p>

          </div>
        </div>
      </div>
    );
  } else if (errorCode == EligibilityErrorCode.E23 && !inputValue) {
    suggestionList = (
      <div
        data-testid="alert-warning"
        style={{ display: eligible }}
        className="alert alert-warning error-reason global-txt"
        role="alert" placeholder="alert-message"
      >
        <span className="global-error-icon covid-error">
          <i className="fas fa-exclamation me-2"></i>
        </span>
        <span className="remove-margin-left">{t(errorCode)}</span>
      </div>
    );
  } else if (errorCode && inputValue) {
    suggestionList = (
      <Message className="error-msg" data-testid="alert-warning">
        {t(errorCode)}
      </Message>
    );
  }
  else if (isLoading) {
    suggestionList = (
      <Loader
        type="ThreeDots"
        color="#00BFFF"
        height={50}
        width={50}
        timeout={5000}
      />
    );
  }

  return (
    <>
      <div className="pt-24">
        <h6>{t("Repair_Reason_Main_Header_Text")}</h6>
        <p className="td">{t("Repair_Reason_Sub-heading_Text")}</p>
        {fetchedRepairReasonsData && (
          <Autocomplete
            className="mtb"
            data-testid="high-level-repair"
            onChange={inputTextChangeHandler}
            inputValue={inputValue}
            onInputChange={suggestionClickHandler}
            id="high-level-repair"
            freeSolo
            disableClearable
            filterOptions={(options, state) => props.suggestions}
            options={props.suggestions}
            size="small"
            renderInput={params => (
              <div ref={params.InputProps.ref}>
                <label htmlFor="html" className="labelform">a</label>
                <input {...params.inputProps}
                  id="html"
                  name="html"
                  placeholder={t("repair_reason_placeholder")}
                  className="txtBox-Input m-0"
                  data-hj-allow=""
                />
              </div>
            )}
          />
        )}
        {suggestionList}
        <p className="pb-20 td">{t("Repair_Reason_Example")}</p>
      </div>
    </>
  );
};

const getSorCode = (
  selectedReason: any,
  supplimentaryCodes: string[]
): string => {
  const isTotalLossOfWaterWithSupplementaryCodes =
    selectedReason?.description === "Total loss of water" &&
    supplimentaryCodes?.includes("FISPUMPS02");

  return isTotalLossOfWaterWithSupplementaryCodes
    ? "COMPUMP"
    : selectedReason?.sors?.[0]?.sorCode;
};


export const heatingAttributeFromResponsibilities = (
  responsibilities: MaintenanceResponsibility[]
) => {
  if (!responsibilities) return "";

  const elementsToCheck: readonly string[] = [
    "HEAT",
    "HEATGAS",
    "HEATOIL",
    "HEATELEC",
  ];
  return responsibilities
    .filter((resp) => elementsToCheck.includes(resp.type))
    .map((resp) => resp.value)
    .filter((value) => {
      const valueLowerCase = value?.toLowerCase();
      return (
        !!value &&
        valueLowerCase !== "null" &&
        valueLowerCase !== "unknown" &&
        valueLowerCase !== "none"
      );
    })
    .join("+");
};
export default RepairReason;